import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import mapicon from "../../img/blue.png";
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
//import { getBusinesses } from "../../actions/advertiseActions";

const posobj = { lat: 40.485, lng: -106.8317 };

const GoogleMapDeal = withGoogleMap(props => (
  <GoogleMap ref={props.onMapLoad} defaultCenter={posobj} defaultZoom={15}>
    {props.markers.map((marker, index) => (
      <Marker
        key={index}
        position={{ lat: marker.lat, lng: marker.lng }}
        onClick={props.onMarkerClick.bind(this, marker.id)}
        icon={mapicon}
      >
        {marker.show && (
          <InfoWindow onCloseClick={props.onCloseClick.bind(this, marker.id)}>
            <div>
              <div className="marker-text">
                <b>{marker.name}&nbsp;{marker.company}&nbsp;{marker.id}</b>
              </div>
              <div className="marker-text">{marker.city}</div>
              <div className="marker-text">{marker.title}</div>
              <div className="marker-text">{marker.lat}&nbsp;{marker.lng}</div>

            </div>
          </InfoWindow>
        )}
      </Marker>
    ))}
  </GoogleMap>
));

class DealMap extends Component {
  constructor(props) {
    super(props);
    this.state = { curmarkerid: "", markers: [], deal: props.deal, lat: props.lat, lon: props.lon };
    // console.log(props);
    // console.log("Dashboard props", props);
    let lat = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidMount() {
    //let link = "/api/business/businesses";
    // let link = "/api/business/business_map";
    // axios
    //   .get(link)
    //   .then(res => {
    //     // dispatch({ type: SET_CURRENT_ADVERTISEMENT, payload: res.data });
    //     console.log(res.data);
    //     let bizes = res.data;
    //     let mary = [];
    //     bizes.map((biz, index) => {
    //       let ads = biz.ads[0];
    //       mary.push({
    //         lat: biz.latitude,
    //         lng: biz.longitude,
    //         name: biz.name,
    //         adname: ads.name,
    //         addesc: ads.description,
    //         addisc: ads.discount,
    //         id: biz._id,
    //         show: false
    //       });
    //       this.setState({ markers: mary });
    //     });
    //   })
    //   // thunk lets us do a dispatch
    //   // .then(res => console.log(res.data))
    //   .catch(err => {
    //     console.log("triggering error in actions", err.message);
    //   });
    let mary = [];
    let { deal } = this.state;
    let mo = {};
    mo['lat'] = deal['latitude'];
    mo['lng'] = deal['longitude'];
    mo['name'] = deal['name'];
    mo['id'] = deal['id'];
    mo['show'] = true;
    mo['title'] = deal.accommodations['title'];
    mo['city'] = deal['city'];
    mo['company'] = deal['company_id'];
    mary.push(mo);
    // console.log(mo);
    this.setState({ markers: mary });
  }



  handleClick(e) {
    console.log("hc e", e);
    e.preventDefault();
  }
  handleCloseClick(bizid) {
    //console.log("handleCloseClick e", bizid);
    // e.preventDefault();
    let smarkers = this.state.markers;
    smarkers.map((marker, index) => {
      if (marker.id === bizid) {
        marker.show = false;
      }
    });

    this.setState({ markers: smarkers });
  }

  handleMarkerClick(bizid) {
    console.log("hmc clicked ", bizid);
    // e.preventDefault();
    //this.setState({ [e.target.name]: e.target.value });
    // let lat = event.latLng.lat();
    // let lng = event.latLng.lng();
    let smarkers = this.state.markers;
    smarkers.map((marker, index) => {
      if (marker.id === bizid) {
        if (marker.show) {
          marker.show = false;
        } else {
          marker.show = true;
        }
      }
    });

    this.setState({ markers: smarkers });

    //console.log("marker clicked index ", bizid);
    // this.props.handleMapClick(lat, lng);
  }

  handleMapLoaded = (map) => {
    // console.log('dom is handleMapLoaded');
    if (map) {
      // console.log('zl', map.getZoom());
    }
  }



  render() {
    //console.log("maplookup props", this.props);
    // console.log("mapbusines render");
    let { lat } = this.state;
    let { lon } = this.state;
    let posobj = { lat: 40.485, lng: -106.8317 };
    let posobj2 = { lat: 40.485, lng: -106.8317 };
    let cposobj = { lat: 40.4863, lng: -106.8328 };
    // console.log("render state is ", this.state);

    // const { businesses } = this.props.advertise;
    // let mary = [];
    // businesses.map((business, index) => {
    //   mary.push({
    //     lat: business.latitude,
    //     lng: business.longitude,
    //     name: business.name,
    //     id: business._id,
    //     show: false
    //   });
    //   console.log(business);
    // });

    if (lat) {
      posobj = { lat: lat, lng: lon };
    }

    // console.log('posobj', posobj);

    let themarkers = this.state.markers;



    return (
      <div>


        {/* <div className="row">
          <div className="col-md-10 offset-md-1 "> */}
        <GoogleMapDeal
          containerElement={
            <div style={{ height: "300px", width: "100%" }} />
          }
          mapElement={<div style={{ height: `100%` }} />}
          markers={themarkers}
          onMarkerClick={this.handleMarkerClick}
          onCloseClick={this.handleCloseClick}
          onMapLoad={this.handleMapLoaded}
        />
        {/* </div>
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  deals: state.deals
});
// the state.auth above comes from rootReducer in index.js in reducers.

export default connect(
  mapStateToProps,
  {}
)(DealMap);



// WEBPACK FOOTER //
// ./src/components/deals/DealMap.js